module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticClass: "custom-back",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('a', {
    staticClass: "back-text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.back()
      }
    },
    slot: "left"
  }, [_vm._v("返回")]), _vm._v("用户关联信息")]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "用户详情 (当前查看用户)"
    }
  }, [_c('cell', {
    attrs: {
      "title": "Email"
    }
  }, [_vm._v(_vm._s(_vm.selectedUser.email))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "用户名"
    }
  }, [_vm._v(_vm._s(_vm.selectedUser.username))]), _vm._v(" "), (_vm.selectedUser.data !== undefined) ? _c('cell', {
    attrs: {
      "title": "中文名"
    }
  }, [_vm._v(_vm._s(_vm.selectedUser.data.local_name))]) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "删除此关联",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showConfirmUnlink = true
      }
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../assets/minus-sign.svg"),
      "width": "21px"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "其他已关联用户"
    }
  }, [_vm._l((_vm.otherUsers), function(user) {
    return _c('cell', {
      key: user.id,
      attrs: {
        "title": _vm.displayName(user),
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(user.id)
        }
      }
    })
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "新增关联",
      "is-link": "",
      "link": "/register"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../assets/plus-sign.svg"),
      "width": "21px"
    },
    slot: "icon"
  })])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "close-on-confirm": false,
      "title": "确定删除关联?"
    },
    on: {
      "on-confirm": function($event) {
        _vm.unlink()
      }
    },
    model: {
      value: (_vm.showConfirmUnlink),
      callback: function($$v) {
        _vm.showConfirmUnlink = $$v
      },
      expression: "showConfirmUnlink"
    }
  }, [_c('p', [_vm._v("删除后，您仍然可以重新创建关联")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3872732"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Links.vue
// module id = 577
// module chunks = 1